<template>
  <small v-if="ready"
    :class="[txtColor, 'me-1']">
      {{text}}
    </small>

</template>

<script lang="js">
import {defineComponent} from 'vue'
export default defineComponent({
    name: "StatusText",
    data(){
        return {
          ready: false,
            txtColor: 'text-primary',
            currentState: -1,
            text: 'test'
        }
    },
    props: {
        status: -1
    },
    computed: {},
    mounted(){
        this.onServicestatusChange()
    },
    unmounted() {
    },

    methods: {

      onServicestatusChange() {
          this.currentState = Number(this.status);

          this.txtColor = 'text-primary';

          // if (this.inMonitoring) {
          switch(this.currentState) {
            case -1:
              this.txtColor = 'text-primary';
              this.text = this.$t('NOT IN MONITORING')
              break;


            case 0:
              this.txtColor = 'text-success';
              this.text = this.$t('Operational');
              break;

            case 1:
              this.txtColor = 'text-warning';
              this.text = this.$t('Performance Issues');
              break;

            case 2:
              this.txtColor = 'text-danger';
              this.text = this.$t('Major Outage');
              break;

            case 3:
              this.txtColor = 'text-secondary';
              this.text = this.$t('Unknown');
              break;
          }
          this.ready = true;
      },
    },

    watch: {
        status: {
            handler(newValue, oldValue) {
                this.onServicestatusChange();
            },
            deep: true,
        },
    }
});
</script>

<style scoped>
.status-circle {
  width: 15px;
  height: 15px;
  padding: 0;
  border-radius: 50%;
}

</style>
